import React from 'react'

const CopyBlueIcon = () => {
    return (
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.99071 3.14844H2.59814C1.71551 3.14844 1 3.86395 1 4.74658V15.4009C1 16.2835 1.71551 16.999 2.59814 16.999H8.99071C9.87334 16.999 10.5889 16.2835 10.5889 15.4009V4.74658C10.5889 3.86395 9.87334 3.14844 8.99071 3.14844Z" stroke="#111AE9" />
            <path d="M3.13281 2.59814C3.13281 1.71551 3.84832 1 4.73095 1H11.1235C12.0061 1 12.7217 1.71551 12.7217 2.59814V13.2524C12.7217 14.135 12.0061 14.8506 11.1235 14.8506" stroke="#111AE9" />
        </svg>
    )
}

export default CopyBlueIcon